import React from "react";
import {Link} from "react-router-dom";
import styles from "./FeedbackTable.module.css";

interface OpenTranscriptButtonProps {
    to: string
}

export const OpenTranscriptButton: React.FC<OpenTranscriptButtonProps> = ({to}) => {
    return <Link to={to} className={styles.openButton} aria-label="Open transcript" title="Open transcript">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
             strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M14 3h7v7"/>
            <path d="M10 14L21 3"/>
            <path d="M18 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5"/>
        </svg>
    </Link>
}
